import React, { useCallback } from 'react';
import { observer } from 'mobx-react';
import moment from 'moment';
import { Datepicker } from '@this/shared/ui/inputs/datepicker/datepicker';
import type OrderItem from '@this/domain/order_item2';

interface Props {
  orderItem: OrderItem;
  classNameForModifiedField?: (...path: (string | number)[]) => string;
}

export const DomesticAirPurchaseDeadlineForm = observer(({ orderItem, classNameForModifiedField }: Props) => {
  const handleChange = useCallback(
    (d: Date | null) => {
      orderItem.purchaseDeadline = d ? moment(d) : undefined;
    },
    [orderItem]
  );

  if (orderItem.orderItemCategory !== 'domestic_air') {
    return null;
  }

  return (
    <div className="virtual-counte-price-change-form__element-block">
      <div className="virtual-counte-price-change-form__input-wrapper">
        <span
          className={`virtual-counte-price-change-form__label ${
            classNameForModifiedField ? classNameForModifiedField('purchaseDeadline') : ''
          }`}
        >
          国内航空券の購入期限
        </span>
        <Datepicker
          value={orderItem.purchaseDeadline?.toDate() || undefined}
          onChange={handleChange}
          type="datetime-local"
        />
      </div>
    </div>
  );
});
